export enum PaymentErrorEnum {
  BlikPaymentError = 'BLIK_PAYMENT_ERROR',
  PolicyAlreadyPaidError = 'POLICY_ALREADY_PAID_ERROR',
  RegisterTransactionError = 'REGISTER_TRANSACTION_ERROR',
}
